import type { JSX } from "preact";
import { useState } from "preact/hooks";

import { type Session, api } from "../api";

/**
 * Bejelentkezés.
 *
 * A hibaüzenet a szervertől jön, és szándékosan NEM mondja meg, hogy a
 * cím vagy a jelszó volt-e rossz — ez a különbségtétel megmondaná a
 * támadónak, mely címekkel érdemes próbálkoznia.
 */
export function Login({ onLogin }: { onLogin: (s: Session) => void }): JSX.Element {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (event: Event): Promise<void> => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onLogin(await api.login(email.trim(), password));
    } catch (e: unknown) {
      setError(e instanceof Error ? e.message : "Nem sikerült a bejelentkezés.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="login">
      <form className="login__box" onSubmit={submit}>
        <p className="eyebrow">Kroki AI</p>
        <h1>Adminisztráció</h1>

        <label>
          E-mail cím
          <input
            type="email"
            autoComplete="username"
            required
            value={email}
            onInput={(e) => setEmail((e.target as HTMLInputElement).value)}
          />
        </label>

        <label>
          Jelszó
          <input
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onInput={(e) => setPassword((e.target as HTMLInputElement).value)}
          />
        </label>

        {error && <p className="notice notice--bad">{error}</p>}

        <button type="submit" className="btn btn--primary" disabled={busy}>
          {busy ? "Belépés…" : "Belépés"}
        </button>

        <p className="muted login__hint">
          Hozzáférést a rendszergazdától kérhet. A munkamenet a böngészőfül
          bezárásakor megszűnik.
        </p>
      </form>
    </main>
  );
}
